import Link from "next/link";
import { Heading, HStack, Icon, Stack, Text } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { FOOTER_CONSTANTS, CONTACT_INFO_LIST } from "../footer.constants";

const FooterContactInfo = () => {
  return (
    <Stack spacing={6} color="white">
      <Heading variant={HEADING_VARIANTS.SUBTITLE2}>
        {FOOTER_CONSTANTS.CONTACT_INFO}
      </Heading>
      <Stack>
        {CONTACT_INFO_LIST.map((contact, index) => {
          return (
            <HStack key={index}>
              <Icon as={contact.icon} fontSize={"18px"} />
              <Text
                as={Link}
                href={contact.path}
                target={contact?.ext_link ? "_blank" : ""}
                _hover={{ textDecor: "underline" }}
              >
                {contact.label}
              </Text>
            </HStack>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default FooterContactInfo;
